import DefaultCRUD from '../utils'

const resource = `/infrastructure/object-types`;

const { get } = DefaultCRUD(resource)

export default {
  get,
}
